module.exports = __webpack_public_path__ + "img/calendar-plus.f6989ec2.svg";